export default __webpack_public_path__ + "static/media/text.eca85c95.svg";